<template>
    <div class="pages flex flex_wrap align_center">
        <div class="fontsize_20 font_weight title">{{ title }}</div>
        <Tooltip v-if="tooltip" :content="tooltip">
            <div class="tag">i</div>
        </Tooltip>
        <div class="ml_auto">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'dataTitle',
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        tooltip: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            //
        };
    },
};
</script>
<style scoped lang="less">
.pages {
    position: relative;
    width: 100%;
    padding: 10px 20px;
    font-size: 20px;
    color: #4c56c0;
    background-color: #f5f6fa;
    border-radius: 6px;
    box-sizing: border-box;

    .title {
        padding: 0 10px;
        border-left: 4px #4c56c0 solid;
    }

    .ml_auto {
        margin-left: auto;
    }

    .tag {
        width: 17px;
        height: 17px;
        line-height: 17px;
        margin-left: 10px;
        margin-top: 10px;
        cursor: pointer;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
        font-size: 15px;
        color: #ffffff;
        background-color: #c4c4c4;
    }
}

@media (max-width: 768px) {
    .pages {
        font-size: 16px;
    }
}
</style>
